// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AIFU","colBig":"styles_colBig__3Wvfp","colSmall":"styles_colSmall__28YoA"};